import Cookie from 'js-cookie';
import superagent from 'superagent';

export const getFbShareUrl = (url) => {
  if (url) {
    return `https://www.facebook.com/sharer/sharer.php?src=sp&u=${encodeURIComponent(url)}`;
  }
  return '';
};

export const getTwitterShareUrl = (url) => {
  if (url) {
    return `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&utm_source=share2`;
  }
  return '';
};

export const getTelegramShareUrl = (url) => {
  if (url) {
    return `tg://msg_url?url=${encodeURIComponent(url)}`;
  }
  return '';
};

export const getWhatsAppShareUrl = (url) => {
  if (url) {
    return `whatsapp://send?text=${encodeURIComponent(url)}`;
  }
  return '';
};

export const getRedditShareUrl = (url) => {
  if (url) {
    return `https://www.reddit.com/submit?url=${encodeURIComponent(url)}`;
  }
  return '';
};

export const getUserPromoLink = async (): Promise<string> => {
  const vid = Cookie.get('vid');
  const res = await superagent.get(
    '/_redirector/link/createForReferralProgram/?campaign=ReferralProgramMobile&forever=true&vid=' +
      vid
  );

  if (res?.body?.newLink && vid) {
    return res.body.newLink;
  }

  return '';
};
